// frontend-executive/src/shared/lib/logger.ts

export type LogLevel = 'DEBUG' | 'INFO' | 'WARN' | 'ERROR'

export interface LogMeta {
  [key: string]: string | number | boolean | null | undefined | LogMeta
}

const LOG_LEVELS: Record<LogLevel, number> = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3
}

export class Logger {
  private level: LogLevel

  constructor(level?: LogLevel) {
    this.level = level || (import.meta.env.DEV ? 'DEBUG' : 'ERROR')
  }

  debug(message: string, meta?: LogMeta): void {
    this.log('DEBUG', message, meta)
  }

  info(message: string, meta?: LogMeta): void {
    this.log('INFO', message, meta)
  }

  warn(message: string, meta?: LogMeta): void {
    this.log('WARN', message, meta)
  }

  error(message: string, meta?: LogMeta): void {
    this.log('ERROR', message, meta)
  }

  private log(level: LogLevel, message: string, meta?: LogMeta): void {
    if (LOG_LEVELS[level] < LOG_LEVELS[this.level]) {
      return
    }

    const timestamp = new Date().toISOString()

    if (import.meta.env.DEV) {
      const consoleMethod = level === 'ERROR' ? 'error' :
                          level === 'WARN' ? 'warn' :
                          level === 'INFO' ? 'info' : 'debug'
      
      const formattedMessage = `[${timestamp}] ${level}: ${message}`
      
      if (meta && Object.keys(meta).length > 0) {
        console[consoleMethod](formattedMessage, meta)
      } else {
        console[consoleMethod](formattedMessage)
      }
    }
  }
}

export const logger = new Logger()